let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bQuOY")).then(() => parcelRequire('6QWjO'));